// eslint-disable-next-line import/no-extraneous-dependencies
import { CSSProperties } from 'react'

export const pageContainerPaddings = (): CSSProperties =>
  ({
    paddingLeft: '10px',
    paddingRight: '40px',
  } as CSSProperties)
